// Функция управления модальным окном
// https://wiki.zina.company/books/frontend/page/modal

export function openModal(
  modalTarget = "#modal", // Обертка с фоном модального окна
  contentSelector = ".modal-content", // Контент модального окна
  closeSelector = ".close", // Кнопка закрытия
  activeSelector = "modal-open", // Признак открытого модального окна, добавляется как класс к <body> и обертке модального окна
  compensateElements = [], // Массив с классами элементов, которым будем добавлять отступ для компенсации ширины прокрутки
  linksInsideCloseModal = false, // Если true, то клик по любой ссылке внутри модального окна будет закрывать его
) {
  const body = document.querySelector("body");

  const modal = document.querySelector(modalTarget);
  if (!modal) return;

  const modalContent = modal.querySelector(contentSelector);

  const modalClose = modal.querySelector(closeSelector);

  const modalDismisses = modal.querySelectorAll("[data-dismiss]");
  const scrollWidth = window.innerWidth - document.documentElement.clientWidth;

  if (body.classList.contains(activeSelector)) {
    closeModal();
  } else {
    // Проверяем наличие полосы прокрутки, чтобы компенсировать "overflow: hidden;"
    if (scrollWidth > 0) {
      body.style.paddingRight = `${scrollWidth}px`;
      adjustScrollbarPadding(scrollWidth, compensateElements);
    }

    body.style.overflow = "hidden";

    // Делаем модальное окно видимым
    modal.style.display = "";
    modal.classList.add(activeSelector);
    body.classList.add(activeSelector);

    // Добавляем обработчики событий для закрытия модального окна
    // Клик на кнопке "Закрыть"
    if (modalClose) {
      modalClose.addEventListener("click", closeModal);
    }

    // Клик на любой ссылке внутри модального окна (если это указано в параметрах)
    if (linksInsideCloseModal) {
      modalContent.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", closeModal);
      });
    }
    // Клик на каждой кнопке с атрибутом "data-dismiss"
    modalDismisses.forEach((dismiss) => {
      dismiss.addEventListener("click", closeModal);
    });

    // Клик на фоне
    window.addEventListener("click", handleBackdropClick);

    // Отключаем закрытие при клике внутри модального окна
    modalContent.addEventListener("click", handleContentClick);

    // Клавиша Esc
    document.addEventListener("keydown", handleEsc);
  }

  // Іменовані хендлери для коректного removeEventListener
  function handleEsc(event) {
    if (event.key === "Escape") {
      closeModal();
    }
  }

  function handleContentClick(event) {
    // при клике в модалке Корзины по Удалить товар перехватывает клик на себя и не даёт удалить
    if (!event.target.parentElement.matches(".cart-block__remove")) {
      event.stopPropagation();
    }
  }

  function handleBackdropClick(e) {
    if (e.target === modal) {
      closeModal();
    }
  }

  // Функция для закрытия модального окна
  function closeModal() {
    modal.style.display = "none";
    modal.classList.remove(activeSelector);
    body.style.overflow = "";
    body.style.paddingRight = "";
    body.classList.remove(activeSelector);

    // Проверяем наличие полосы прокрутки, чтобы компенсировать "overflow: hidden;"
    const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollWidth > 0) {
      adjustScrollbarPadding(-scrollWidth, compensateElements);
    }
    // Удаляем обработчики событий
    if (modalClose) {
      modalClose.removeEventListener("click", closeModal);
    }
    modalDismisses.forEach((dismiss) => {
      dismiss.removeEventListener("click", closeModal);
    });
    window.removeEventListener("click", handleBackdropClick);
    modalContent.removeEventListener("click", handleContentClick);
    document.removeEventListener("keydown", handleEsc);
  }

  // Функция для добавления и убирания отступа, компенсирующего ширину прокрутки
  function adjustScrollbarPadding(scrollWidth, compensateElements) {
    if (scrollWidth !== 0 && compensateElements) {
      compensateElements.forEach((className) => {
        var compensateElementsElement = document.querySelector(className);
        if (compensateElementsElement) {
          const currentPaddingRight = parseInt(
            getComputedStyle(compensateElementsElement).paddingRight,
            10,
          );
          compensateElementsElement.style.paddingRight = `${currentPaddingRight + scrollWidth}px`;
        }
      });
    }
  }
}
